import Button from 'common/components/Button'
import themes from 'common/theme'
import Link from 'next/link'
import FilterCheckIcon from 'services/LocalStorefront/assets/svg/filter-check/filter-check.svg'
import FilterIcon from 'services/LocalStorefront/assets/svg/filter/filter.svg'
import KonektoIcon from 'services/LocalStorefront/assets/svg/konekto-logo/konekto-logo.svg'
import Search from 'services/LocalStorefront/components/Search'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: sticky;
  display: flex;
  justify-content: center;
  height: 90px;
  top: 0;
  background-color: ${themes.colors.white};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  z-index: ${themes.zIndex.konektoHeader};
`

const Container = styled.div`
  width: ${themes.layout.containerWidth};
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const WrapperIcon = styled.div`
  cursor: pointer;
`

const StyledButton = styled(Button)`
  color: ${themes.colors.black};
  ${({ active }) =>
    active
      ? `
      border-color: ${themes.colors.primaryKonekto};
      background-color: ${themes.colors.primaryKonekto10}
    `
      : ''}
`

function Header({
  isFiltered = true,
  toogleFilter,
}: {
  isFiltered?: boolean
  toogleFilter: Function
}): JSX.Element {
  return (
    <Wrapper>
      <Container>
        <Link href="/local-store">
          <WrapperIcon>
            <KonektoIcon />
          </WrapperIcon>
        </Link>
        <Search
          width="635px"
          placeholder="Cari nama usaha disini"
          hideHelperText
        />
        <StyledButton
          color="grayLight"
          fontWeight="bold"
          size={themes.typography.bh5.fontSize}
          letterCase="capitalize"
          onClick={toogleFilter}
          variant="outlined"
          withIcon={{
            icon: isFiltered ? <FilterCheckIcon /> : <FilterIcon />,
            position: 'left',
          }}
          active={isFiltered}
        >
          Filter
        </StyledButton>
      </Container>
    </Wrapper>
  )
}

export default Header
